export default __webpack_public_path__ + "./images/bm.804a7199.png";